<div  style="width: 100%;">
    <p-panel header="Volumétrie fiches traitées OK/KO dans le temps" styleClass="qos-init">
        <p-chart [data]="volumetrieTraitees" [options]="volumetrieTraiteesOptions" type="bar" [height]="'310'"></p-chart>
    </p-panel>
</div>
